export default __webpack_public_path__ + "static/media/cart.58728781.svg";